import { Routes } from '@angular/router';
import { platformAdminPortalGuard } from './core/services/platform-admin-portal.guard';
import { PlatformAdminShell } from './shell/platform-admin-shell/platform-admin-shell';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/platform-admin-login').then((m) => m.PlatformAdminLogin),
  },
  {
    path: '',
    component: PlatformAdminShell,
    canActivateChild: [platformAdminPortalGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/platform-admin-dashboard').then((m) => m.PlatformAdminDashboard),
      },
      {
        path: 'organizations',
        loadComponent: () => import('./pages/organizations/platform-organizations').then((m) => m.PlatformOrganizations),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/platform-users').then((m) => m.PlatformUsers),
      },
      {
        path: 'invitations',
        loadComponent: () => import('./pages/invitations/platform-invitations').then((m) => m.PlatformInvitations),
      },
      {
        path: 'roles',
        loadComponent: () => import('./pages/roles/platform-roles').then((m) => m.PlatformRoles),
        data: { title: 'Roles & Permissions', subtitle: 'Review platform roles, scoped access, MFA posture, and permission changes.' },
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/subscriptions/platform-subscriptions').then((m) => m.PlatformSubscriptions),
      },
      {
        path: 'screening',
        loadComponent: () => import('./pages/screening-settings/platform-screening-settings').then((m) => m.PlatformScreeningSettings),
      },
      {
        path: 'payment-fees',
        loadComponent: () => import('./pages/payment-fees/platform-payment-fees').then((m) => m.PlatformPaymentFees),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./pages/transactions/platform-transactions').then((m) => m.PlatformTransactions),
      },
      {
        path: 'account-deletions',
        loadComponent: () => import('./pages/account-deletion-requests/platform-account-deletion-requests').then((m) => m.PlatformAccountDeletionRequests),
      },
      // The page used to sit under "Support"; keep old links and bookmarks working.
      { path: 'support', redirectTo: 'account-deletions', pathMatch: 'full' },
      {
        path: 'security',
        loadComponent: () => import('./pages/security/platform-security').then((m) => m.PlatformSecurity),
      },
      {
        path: 'audit-logs',
        loadComponent: () => import('./pages/audit-logs/platform-audit-logs').then((m) => m.PlatformAuditLogs),
      },
      {
        path: 'integrations',
        loadComponent: () => import('./pages/integrations/platform-integrations').then((m) => m.PlatformIntegrations),
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/reports/platform-reports').then((m) => m.PlatformReports),
        data: { title: 'Reports', subtitle: 'Platform-wide operational reporting and exports.' },
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/platform-settings').then((m) => m.PlatformSettings),
        data: { title: 'Settings', subtitle: 'Platform account preferences and administrative controls.' },
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
